export const parseVenueIds = (venueIds) => {
  if (Array.isArray(venueIds)) {
    return venueIds;
  }
  if (venueIds) {
    return [Number(venueIds)];
  }
  return [];
};
